import React from "react";
import logo from "../../assets/scee_logo_square.webp";
import { useAccountMenuState } from "./hooks/use-account-menu-state";
import { AccountMenuItem } from "./components/menu-item";
export function AccountMenu({ className = "" }) {
    const { fullName, selected, menuItems, handleMenuItemClicked } = useAccountMenuState();
    return (React.createElement("div", { className: `w-full ${className}` },
        React.createElement("div", { className: "w-full rounded-2xl bg-light-blue p-4" },
            React.createElement("div", { className: "flex flex-row items-center w-full gap-4 px-4 py-4" },
                React.createElement("img", { className: "w-10 h-10 bg-cover", alt: "logo", src: logo }),
                React.createElement("div", { className: "text-primary font-semibold" }, fullName)),
            React.createElement("div", { className: "flex flex-col gap-4 py-4" }, menuItems.map((menuItem) => (React.createElement(AccountMenuItem, { key: menuItem.identifier, ...menuItem, selected: menuItem.identifier === selected?.identifier, onMenuItemClicked: handleMenuItemClicked })))))));
}
